<div class="reporting-stations-dashboard">
  <sc-flex vertical stretchContent fitHeight>

    <div class="menu widget-menu-layer-1">
      <sc-flex>
        <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
        <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
        <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
      </sc-flex>
    </div>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex-fitting-content vertical>
      <app-stacked-bar-chart [data]="data.chart" *ngIf=" data != null"></app-stacked-bar-chart>
    </sc-flex-fitting-content>

  </sc-flex>

</div>
